var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cont"},[_c('router-view',{staticClass:"content"}),_c('BaseFooter'),(_vm.userList.length > 0)?_c('Depositdue'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }